import React from 'react';
import { HOUSING_TYPES, PROJECT_INFO } from './constants';

const StepHousingType = ({ formData, onHousingTypeChange }) => {
  return (
    <div className="animate-fadeIn">
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
        Konut Tipi Seçimi
      </h2>
      <p className="text-gray-600 mb-6">
        Ön başvuruda bulunmak istediğiniz konut tipini seçiniz. Her başvuru sahibi yalnızca tek bir konut tipine
        ön başvuru yapabilir. Bedellerin tamamını önceki adımdaki ödeme tablosunda görebilirsiniz.
      </p>

      {/* Seçim kartları */}
      <div className="space-y-3 mb-8">
        {HOUSING_TYPES.map((tip) => {
          const secili = formData.konutTipi === tip.kod;

          return (
            <button
              key={tip.kod}
              type="button"
              onClick={() => onHousingTypeChange(tip.kod)}
              aria-pressed={secili}
              className={`
                w-full text-left rounded-2xl border-2 overflow-hidden transition-all duration-200 active:scale-[0.99]
                flex items-stretch
                ${secili
                  ? 'border-primary bg-primary-light shadow-md'
                  : 'border-gray-200 bg-white hover:border-gray-300'
                }
              `}
            >
              {/* Tip rengi şeridi */}
              <span className={`w-1.5 flex-shrink-0 ${secili ? 'bg-primary' : 'bg-gray-200'}`} aria-hidden="true" />

              <span className="flex items-center gap-4 flex-1 p-4">
                {/* Seçim göstergesi */}
                <span
                  className={`
                    w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0
                    ${secili ? 'border-primary bg-primary' : 'border-gray-300 bg-white'}
                  `}
                >
                  {secili && (
                    <svg className="w-3.5 h-3.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={4} d="M5 13l4 4L19 7" />
                    </svg>
                  )}
                </span>

                <span className="flex-1 min-w-0">
                  <span className="flex items-baseline flex-wrap gap-x-2">
                    <span className={`text-lg font-bold ${secili ? 'text-primary' : 'text-gray-900'}`}>
                      {tip.metrekare}
                    </span>
                    <span className="text-sm font-semibold text-gray-600">{tip.konsept}</span>
                  </span>
                  <span className="block text-xs text-gray-500 mt-0.5">
                    {tip.baslik} · {tip.daireSayisi} daire
                  </span>
                  <span className="block text-[11px] text-gray-500 mt-1">
                    Peşinat {tip.pesinat} · Aidat {tip.aidat}
                  </span>
                </span>

                <span className="text-right flex-shrink-0">
                  <span className="block text-[10px] uppercase tracking-wider text-gray-500 font-bold">
                    Ön Başvuru
                  </span>
                  <span className={`block text-base font-bold ${secili ? 'text-primary' : 'text-gray-900'}`}>
                    {tip.onBasvuruBedeli}
                  </span>
                </span>
              </span>
            </button>
          );
        })}
      </div>

      {/* Kura ve süreç bilgilendirmesi */}
      <div className="mt-6 p-5 bg-primary-light rounded-xl border border-primary/20">
        <h3 className="font-semibold text-gray-900 mb-3 flex items-center">
          <svg className="w-5 h-5 text-primary mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          Bilgilendirme
        </h3>
        <ul className="space-y-2 text-sm text-primary-text leading-relaxed list-disc list-inside">
          <li>
            Ön başvuru bedeli, başvurunuz oluşturulduktan sonra ekranda gösterilecek IBAN'a, sistem tarafından
            otomatik üretilen açıklama ile yatırılır.
          </li>
          <li>
            Bedeli yatırılmayan kayıtlar geçerli ön başvuru sayılmaz ve kuraya dâhil edilmez.
          </li>
          <li>
            Projeye toplam <span className="font-semibold">{PROJECT_INFO.alinacakUyeSayisi} yeni üye</span> kabul edilecektir.
            Ön başvuru sayısı daire sayısını aşarsa kesin üyeler
            <span className="font-semibold"> noter huzurunda yapılacak kura</span> ile belirlenecektir.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default StepHousingType;
